import {
  AfterViewInit,
  ApplicationRef,
  Component,
  ElementRef,
  Injector,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import {
  BmarkHedgeOrdersTableDefinitionFactory,
  ProfilePromiseActionService,
  SystemConfigPromiseService,
} from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TranslateService } from "@ngx-translate/core";
import { BmarkHedgeOrdersBlotterComponent } from "app/bfx-bmark-summary/blotters/hedge-orders/bmark-hedge-orders-blotter.component";
import { provideBlotter } from "../../../bfx-base-blotter/bfx-base-blotter";
import { BfxBaseBlotterColumnSelectorService } from "../../../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxBlotterFilterService } from "../../../bfx-blotter-filter/bfx-blotter-filter.service";
import { BfxMouseModifierKeyService } from "../../../bfx-common/services/bfx-mouse-modifier-key.service";
import { BfxSaveProfileNotificationService } from "../../../bfx-common/services/bfx-save-profile-notification.service";
import { BfxUserProfileService } from "../../../bfx-common/services/bfx-user-profile.service";
import { GoldenLayoutService } from "../../../golden-layout/golden-layout-service";
import { BmarkSummaryUtilService } from "../../services/bmark-summary-util.service";
import { BmarkHedgeOrdersContextMenuService } from "./services/bmark-hedge-orders-context-menu.service";
import { BmarkHedgeOrdersDataService } from "./services/bmark-hedge-orders-data.service";
import { BmarkHedgeOrdersFilterService } from "./services/bmark-hedge-orders-filter.service";

/**
 * A version of the BmarkHedgeOrdersBlotterComponent used for disaplying hedge orders in the HOM that uses a local
 * instance of a BMarkHedgeOrderService and should be marked as embedded
 */
@Component({
  selector: "bmark-hom-orders-blotter",
  templateUrl: "./html/bmark-hedge-orders-blotter.html",
  encapsulation: ViewEncapsulation.None,
  providers: [provideBlotter(BmarkHOMOrdersBlotterComponent), BmarkHedgeOrdersDataService],
  viewProviders: [BfxBaseBlotterColumnSelectorService],
  standalone: false,
})
export class BmarkHOMOrdersBlotterComponent
  extends BmarkHedgeOrdersBlotterComponent
  implements AfterViewInit, OnDestroy, OnInit, OnChanges
{
  constructor(
    BfxBlotterElement: ElementRef,
    applicationRef: ApplicationRef,
    injector: Injector,
    service: BmarkHedgeOrdersDataService,
    contextMenuServices: BmarkHedgeOrdersContextMenuService,
    zone: NgZone,
    tableDefinitionFactory: BmarkHedgeOrdersTableDefinitionFactory,
    layoutService: GoldenLayoutService,
    translationService: TranslateService,
    blotterFilterService: BfxBlotterFilterService,
    filteringService: BmarkHedgeOrdersFilterService,
    columnSelectorService: BfxBaseBlotterColumnSelectorService,
    profileActionService: ProfilePromiseActionService,
    sysConfigService: SystemConfigPromiseService,
    mouseModifierKeyService: BfxMouseModifierKeyService,
    saveProfileNotificationService: BfxSaveProfileNotificationService,
    userProfileService: BfxUserProfileService,
    bmarkSummaryUtilService: BmarkSummaryUtilService,
  ) {
    super(
      BfxBlotterElement,
      applicationRef,
      injector,
      service,
      contextMenuServices,
      zone,
      tableDefinitionFactory,
      layoutService,
      translationService,
      blotterFilterService,
      filteringService,
      columnSelectorService,
      profileActionService,
      sysConfigService,
      mouseModifierKeyService,
      saveProfileNotificationService,
      userProfileService,
      bmarkSummaryUtilService,
    );
  }
}
